import { baseApi, extractData } from "../api/axiosConfig";


export const getSomeContracts = filterAPI =>
    baseApi.get(`/contract/${filterAPI}`)
        .then(extractData);


export const getContractsByType = filterAPI =>
    baseApi.get("/contract/type", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);


export const getAllContracts = () =>
    baseApi.get("/contract")
        .then(extractData);


export const addContract = data =>
    baseApi.post("/contract/create", data)
        .then(extractData);


export const editContract = (id, partial) =>
    baseApi.patch(`/contract/${encodeURIComponent(id)}`, partial)
        .then(extractData);


export const deleteContract = contractId =>
    baseApi.delete(`/contract/${contractId}`)
        .then(extractData);


export const getCBAContracts = () =>
    baseApi.get("/contract/CBA")
        .then(extractData);


export const getSideletterContracts = () =>
    baseApi.get("/contract/Sideletter")
        .then(extractData);


export const getNewC = () =>
    baseApi.get("/contract/newC")
        .then(extractData);


export const getSampleContracts = () =>
    baseApi.get("/contract/SampleContracts")
        .then(extractData);


export const getConfigContracts = () =>
    baseApi.get("/contract/Configs")
        .then(extractData);


export const getContractById = contractId =>
    baseApi.get(`/contract/${contractId}`)
        .then(extractData);


export const createNewDataSet = () =>
    baseApi.get("/contract/newDataSet")
        .then(extractData);


export const newMasterContract = contractAPI =>
    baseApi.get("/contract/newMasterContract", {
            params: { contract_api: contractAPI }
        })
        .then(extractData);


export const advanceContract = id =>
    baseApi.get("/contract/advanceContract", {
            params: { target_contract_id: id }
        })
        .then(extractData);


export const createRelatedContract = id =>
    baseApi.get("/contract/newResContract", {
            params: { original_c_id: id }
        })
        .then(extractData);


export const getProductContracts = myProductId =>
    baseApi.get("/contract/productContracts", {
            params: { my_product_id: myProductId }
        })
        .then(extractData);


export const createNewContract = (userId, userName, userDepartment) =>
    baseApi.get("/contract/newContract", {
            params: {
                user_id: userId,
                user_name: userName,
                user_department: userDepartment
            }
        })
        .then(extractData);


export const getProductContractHierarchy = (myTitleId, multiSingle) =>
    baseApi.get("/contract/productContractHierarchy", {
            params: {
                my_title_id: myTitleId,
                multi_single: multiSingle
            }
        })
        .then(extractData);


export const getQueueC = () =>
    baseApi.get("/contract/queueC")
        .then(extractData);


export const getMissingInput = contractId =>
    baseApi.get("/contract/missingInput", {
            params: { contract_id: contractId }
        })
        .then(extractData);


export const addChildContracts = (selectorContractId, contractCount) =>
    baseApi.get("/contract/addChildren", {
            params: {
                parent_contract_id: selectorContractId,
                children_requested: contractCount
            }
        })
        .then(extractData);


export const deleteContractsByProductId = contractId =>
    baseApi.get("/contract/deleteByProduct", {
            params: { my_contract_id: contractId }
        })
        .then(extractData);


export const deleteContractById = contractId =>
    baseApi.get("/contract/deleteById", {
            params: { my_contract_id: contractId }
        })
        .then(extractData);


export const getContractHeaderStandard = myContractId =>
    baseApi.get("/contract/header", {
            params: { my_contract_id: myContractId }
        })
        .then(extractData);

export const updateContractStatus = (newStatus, selectorContractId) =>
    baseApi.get("/contract/updateStatus", {
            params: {
                new_status: newStatus,
                my_contract_id: selectorContractId
            }
        })
        .then(extractData);

export const updateStatusByContractList = (myContractList, newStatus) =>
    baseApi.get("/contract/updateStatusByContractList", {
            params: {
                my_contract_list: myContractList,
                new_status: newStatus
            }
        })
        .then(extractData);

export const advanceApproved = myContractId =>
    baseApi.get("/contract/advanceApproved", {
            params: { my_contract_id: myContractId }
        })
        .then(extractData);

export const advanceToPayment = myContractId =>
    baseApi.get("/contract/advanceToPayment", {
            params: { my_contract_id: myContractId }
        })
        .then(extractData);

export const calcObligationOwed = myContractList =>
    baseApi.get("/contract/calcObligationOwed", {
            params: { my_contract_list: myContractList }
        })
        .then(extractData);

export const advanceApprovedByGuild = (
    selectorContractId,
    selectorContractProperty,
    selectorContractLevel,
    selectorContractGuild
) =>
    baseApi.get("/contract/advanceApprovedByGuild", {
            params: {
                my_contract_id: selectorContractId,
                my_property_id: selectorContractProperty,
                my_contract_level: selectorContractLevel,
                my_guild: selectorContractGuild
            }
        })
        .then(extractData);

export const copyContract = (selectorContractId, targetType) =>
    baseApi.get("/contract/copyContract", {
            params: {
                original_c_id: selectorContractId,
                target_type: targetType
            }
        })
        .then(extractData);

export const refreshContractName = (selectorContractId, selectorCdpId, selectorValue2) =>
    baseApi.get("/contract/refreshName", {
            params: {
                my_contract_id: selectorContractId,
                my_cdp_id: selectorCdpId,
                my_data_point_value: selectorValue2
            }
        })
        .then(extractData);

export const getContractCsList = selectorContractId =>
    baseApi.get("/contract/csList", {
            params: { contract_id: selectorContractId }
        })
        .then(extractData);

export const getContractCsfList = (selectorContractId, selectorDataPointId) =>
    baseApi.get("/contract/csfList", {
            params: {
                contract_id: selectorContractId,
                data_point_id: selectorDataPointId
            }
        })
        .then(extractData);

export const getContractCdpList = (selectorContractId, selectorDataPointId) =>
    baseApi.get("/contract/cdpList", {
            params: {
                contract_id: selectorContractId,
                data_point_id: selectorDataPointId
            }
        })
        .then(extractData);

export const getContractCdpvList = (selectorContractId, selectorDataPointId) =>
    baseApi.get("/contract/cdpvList", {
            params: {
                contract_id: selectorContractId,
                data_point_id: selectorDataPointId
            }
        })
        .then(extractData);

export const getContractCdpvfList = (selectorContractId, selectorDataPointId) =>
    baseApi.get("/contract/cdpvfList", {
            params: {
                contract_id: selectorContractId,
                data_point_id: selectorDataPointId
            }
        })
        .then(extractData);

export const getContractVocabularyList = selectorContractId =>
    baseApi.get("/contract/vocabularyList", {
            params: { contract_id: selectorContractId }
        })
        .then(extractData);

export const getContractStatusPie = filterAPI =>
    baseApi.get("/contract/statusPie", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);

export const getContractGuildPie = filterAPI =>
    baseApi.get("/contract/guildPie", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);

export const getContractM4mktPie = filterAPI =>
    baseApi.get("/contract/m4mktPie", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);

export const getContractLevelPie = filterAPI =>
    baseApi.get("/contract/levelPie", {
            params: { contract_type: filterAPI }
        })
        .then(extractData);

export const deleteMultipleContractsById = myContractList =>
    baseApi.get("/contract/deleteMultipleById", {
            params: { my_contract_list: myContractList }
        })
        .then(extractData);

export const getContractStatsContractType = () =>
    baseApi.get("/contract/contractStatsContractType")
        .then(extractData);

export const getContractStatsMarketGroup = () =>
    baseApi.get("/contract/contractStatsMarketGroup")
        .then(extractData);

export const getContractStatsReleaseMarket = () =>
    baseApi.get("/contract/contractStatsReleaseMarket")
        .then(extractData);

export const getContractStatsStandAlone = () =>
    baseApi.get("/contract/contractStatsStandAlone")
        .then(extractData);

export const getContractStatsSeries = () =>
    baseApi.get("/contract/contractStatsSeries")
        .then(extractData);

export const getContractStatsSeason = mySeriesId =>
    baseApi.get("/contract/contractStatsSeason", {
            params: { series_id: mySeriesId }
        })
        .then(extractData);

export const getContractStatsEpisode = mySeasonId =>
    baseApi.get("/contract/contractStatsEpisode", {
            params: { season_id: mySeasonId }
        })
        .then(extractData);

export const getContractStatsGuild = myProductId =>
    baseApi.get("/contract/contractStatsGuild", {
            params: { product_id: myProductId }
        })
        .then(extractData);

export const contractSearch = (
    selectorId,
    selectorIdFrom,
    selectorIdTo,
    selectorContractType,
    selectorMcode,
    selectorName,
    selectorCreatedOn,
    selectorCreatedFrom,
    selectorCreatedTo
) =>
    baseApi.get("/contract/contractSearch", {
            params: {
                myId: selectorId,
                myIdFrom: selectorIdFrom,
                myIdTo: selectorIdTo,
                myContractType: selectorContractType,
                myMcode: selectorMcode,
                myName: selectorName,
                myCreatedOn: selectorCreatedOn,
                myCreatedFrom: selectorCreatedFrom,
                myCreatedTo: selectorCreatedTo
            }
        })
        .then(extractData);

export const generateContractFromAbstract = (abstractId, userId, userName, userDepartment) =>
    baseApi.get("/contract/generateContractFromAbstract", {
            params: {
                abstract_id: abstractId,
                user_id: userId,
                user_name: userName,
                user_department: userDepartment
            }
        })
        .then(extractData);

export const generateContractFromMasterContract = (
    masterContractId,
    contractLevelName,
    userId,
    userName,
    userDepartment
) =>
    baseApi.get("/contract/generateContractFromMasterContract", {
            params: {
                master_contract_id: masterContractId,
                contract_level_name: contractLevelName,
                user_id: userId,
                user_name: userName,
                user_department: userDepartment
            }
        })
        .then(extractData);

export const moveContract = (myContractId, moveDirection, contractType) =>
    baseApi.get("/contract/moveContract", {
            params: {
                my_contract_id: myContractId,
                move_direction: moveDirection,
                contract_type: contractType
            }
        })
        .then(extractData);

export const deleteSingleContract = myContractId =>
    baseApi.get("/contract/deleteSingleContract", {
            params: { my_contract_id: myContractId }
        })
        .then(extractData);

export const getContractProduct = myContractId =>
    baseApi.get("/contract/contractProduct", {
            params: { myContractId }
        })
        .then(extractData);


export const updateAbstractStatus = (myContractId, newStatus) =>
    baseApi.get("/contract/updateAbstractStatus", {
            params: {
                my_contract_id: myContractId,
                new_status: newStatus
            }
        })
        .then(extractData);

export const contractUpdate = (
    myContractList,
    myGuildList,
    myMarketList,
    myContractAction,
    myContractNewValue,
    myVersionNumber,
    myCurrentUserName,
    myBatchEvents
) =>
    baseApi
        .post("/contract/contractUpdateWithTest", {
            p_contract_list: myContractList,
            guild_list: myGuildList,
            market_list: myMarketList,
            p_contract_action: myContractAction,
            p_contract_new_value: myContractNewValue,
            p_version_number: myVersionNumber,
            p_current_user_name: myCurrentUserName,
            p_batch_events: myBatchEvents
        })
        .then(extractData);

export const contractUpdateWithTest = (
    myContractList,
    myGuildList,
    myMarketList,
    myContractAction,
    myContractNewValue,
    myVersionNumber,
    myCurrentUserName,
    myBatchEvents,
    myTestScenarioNumber,
    myTestScenarioName,
    myTestScenarioProductId,
    myTestScenarioPeriodEndDate
) =>
    baseApi
        .post("/contract/contractUpdateWithTest", {
            p_contract_list: myContractList,
            guild_list: myGuildList,
            market_list: myMarketList,
            p_contract_action: myContractAction,
            p_contract_new_value: myContractNewValue,
            p_version_number: myVersionNumber,
            p_current_user_name: myCurrentUserName,
            p_batch_events: myBatchEvents,
            p_test_scenario_number: myTestScenarioNumber,
            p_test_scenario_name: myTestScenarioName,
            p_test_scenario_property_id: myTestScenarioProductId,
            p_test_scenario_period_end_date: myTestScenarioPeriodEndDate
        })
        .then(extractData);



export const advance = (batchId, batchEvents, userName, versionNumber, contractId, advanceMode) =>
    baseApi.get("/contract/advance", {
        params: {
            my_batch_id: batchId,
            my_batch_events: batchEvents,
            my_user_name: userName,
            my_version_number: versionNumber,
            initial_contract_id: contractId,
            my_mode: advanceMode

        }
    })
        .then(extractData);


export const getGeneratedAbstractCount = myContractId =>
    baseApi.get("/contract/generatedAbstractCount", {
        params: { my_contract_id: myContractId }
    })
        .then(extractData);



export const getBlockingPartsDeal = myContractId =>
    baseApi.get("/contract/blockingPartsDeal", {
        params: { my_contract_id: myContractId }
    })
        .then(extractData);


export const getBlockingGuild = myContractId =>
    baseApi.get("/contract/blockingGuild", {
        params: { my_contract_id: myContractId }
    })
        .then(extractData);

